module.exports = __webpack_public_path__ + "img/poly-10.7854fb15.png";